import { v4 as uuidv4 } from 'uuid'
import {
  CnDatahubCategoryAccess,
  CnDatahubCategoryAccessFilter,
  CnDatahubCategoryColumn,
} from './datahub-interfaces'
import { createEmptyFilterGroup, serializeFilterGroup } from './datahubFilter'
import { defaultOrderKeyForIndex } from './datahubOrderKey'

/** Reserved datakey / label for the private-category title column (tool identifier). */
export const DATAHUB_PRIVATE_TITLE_KEY = 'title'

/**
 * Create the mandatory title column for a private category.
 * Used as identifier in the CN tool (card hover label, table link to open the popup).
 */
export function createPrivateTitleColumn(categoryId: string): CnDatahubCategoryColumn {
  return {
    id: uuidv4(),
    categoryId,
    categoryAccessId: null,
    categoryColumnId: null,
    label: DATAHUB_PRIVATE_TITLE_KEY,
    datakey: DATAHUB_PRIVATE_TITLE_KEY,
    name: 'Titre',
    type: 'text',
    required: true,
    visible: true,
    options: null,
    description: null,
    orderKey: defaultOrderKeyForIndex(0),
  }
}

export function isPrivateTitleColumn(column: CnDatahubCategoryColumn): boolean {
  return column.datakey === DATAHUB_PRIVATE_TITLE_KEY
}

/**
 * Create a default datahub category access for a category
 * @param orgaId - The ID of the organization
 * @param categoryId - The ID of the category
 * @returns The default access
 */
export function createDefaultDatahubCategoryAccess(orgaId: string, categoryId: string): CnDatahubCategoryAccess {
  return {
    id: uuidv4(),
    orgaId,
    categoryId,
    overrideName: null,
    color: '#1677ff',
    linkContactMax: 5,
    linkAttachmentMax: 5,
    linkEntrepriseMax: 5,
    linkRdvMax: 5,
    removeManualCreation: false,
  }
}

/**
 * Create a default datahub category access filter for a category access
 * @param categoryAccessId - The ID of the category access
 * @returns The default filter (empty AND group)
 */
export function createDefaultDatahubCategoryAccessFilter(categoryAccessId: string): CnDatahubCategoryAccessFilter {
  return {
    id: uuidv4(),
    categoryAccessId,
    jsonFilter: serializeFilterGroup(createEmptyFilterGroup()),
  }
}

/** Ensure an enabled shared category always has a filter object to edit. */
export function ensureSharedCategoryFilter(config: {
  access: CnDatahubCategoryAccess | null
  filter: CnDatahubCategoryAccessFilter | null
}): CnDatahubCategoryAccessFilter | null {
  if (!config.access) return null
  return config.filter ?? createDefaultDatahubCategoryAccessFilter(config.access.id)
}
